module.exports = {"initialValues":{"consumerId":"FOMO","hasMembershipCheck":true,"showExtraMembership":true,"hasPartnerPermissionConsent":true,"campaignDescription":"Lovligt frafald Min side – FOMO"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/packages/businessUnit/package.fomo-override-global.json
// module id = 679
// module chunks = 0